<script lang="ts">
    import Vue from "vue";
    import { send } from './AppRT';

    export default Vue.extend({
        beforeRouteEnter(to, from, next) {
            // called before the route that renders this component is confirmed.
            // does NOT have access to `this` component instance,
            // because it has not been created yet when this guard is called!
            //console.log(to, from)
            send("Runtime", "DispatchHash", to.path);
            next();
        },
        beforeRouteUpdate(to, from, next) {
            // called when the route that renders this component has changed,
            // but this component is reused in the new route.
            // For example, for a route with dynamic params `/foo/:id`, when we
            // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
            // will be reused, and this hook will be called when that happens.
            // has access to `this` component instance.
            //console.log(to, from)
            send("Runtime", "DispatchHash", to.path);
            next();
        }
    });
</script>

<template>
    <div id="contentRoot">
        <h3 style="margin: 20px;">Launching application...</h3>
    </div>
</template>